export default __webpack_public_path__ + "static/Pala_15-247580a470b9bfde8aa3bb5c784042a5.png";